import PercentageChart from './PercentageChart';

export default PercentageChart;



// WEBPACK FOOTER //
// ./src/components/reusable/PercentageChart/index.js